var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// constants
import Routes from '@/constants/Routes';
import { LOGIN_TYPE } from '@/constants/login';
import { localStorageKeys } from '@/constants/storage';
// helpers
import { EnvConfigMap, getEnvironmentViaHostname } from '@/helpers/env';
import { readFromLocalStorage, writeToLocalStorage } from '@/helpers/storage';
export const initiateUnauthorizedRequestLogout = () => __awaiter(void 0, void 0, void 0, function* () {
    yield initiateLogout();
    const loginType = yield readFromLocalStorage(localStorageKeys.LOGIN_TYPE);
    const loginEndpoint = loginType === LOGIN_TYPE.INTERNAL
        ? Routes.EMPLOYEE_LOGIN
        : Routes.EXTERNAL_LOGIN;
    const url = `${EnvConfigMap[getEnvironmentViaHostname()].clientBasePath}/instamart${loginEndpoint}`;
    window.location.href = url;
});
const unsetTokensAndLoginDetails = () => __awaiter(void 0, void 0, void 0, function* () {
    return Promise.all([
        writeToLocalStorage(localStorageKeys.ACCESS_TOKEN, ''),
        writeToLocalStorage(localStorageKeys.REFRESH_TOKEN, ''),
        writeToLocalStorage(localStorageKeys.CODE_VERIFIER, ''),
        writeToLocalStorage(localStorageKeys.CODE_CHALLENGE, ''),
        writeToLocalStorage(localStorageKeys.CURRENT_ACCOUNT_ID, ''),
    ]);
});
export const initiateLogout = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield unsetTokensAndLoginDetails();
    }
    catch (error) {
        if (__DEV__) {
            console.error(error);
        }
    }
});
